import add_should_refresh_config from './v0_add_should_refresh_config.js'
import partition_refund_ids from './v1_partition_refund_ids.js'
import add_mode_configuration from './v2_add_mode_configuration.js'
import add_revenue_center_tree from './v3_add_revenue_center_tree.js'
import change_offline_local_ids_name from './v4_change_offlineLocalIds_to_unsyncedOrderIds.js'
import add_delta_sync_to_order from './v5_add_delta_sync_to_order.js'
import remove_persistence from './v6_remove_persistence.js'
import peripheral_connected_default_ready from './v7_peripheral_connected_default_ready.js'
import show_closed_tabs_default_to_false from './v8_show_closed_tabs_default_to_false.js'

const migrations = {
  ...add_should_refresh_config,
  ...partition_refund_ids,
  ...add_revenue_center_tree,
  ...add_mode_configuration,
  ...change_offline_local_ids_name,
  ...add_delta_sync_to_order,
  ...remove_persistence,
  ...peripheral_connected_default_ready,
  ...show_closed_tabs_default_to_false,
}

export default migrations
